import React, { useEffect, useState } from 'react'
import { MenuItem, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { useLocation } from 'react-router-dom'

// COMPONENT
import FilterSelect from '../../../../../component/select/filterSelect'
import InputTextField from '../../../../../component/input/inputTextField'


// TEST
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import LabelCustom from '../../../../../component/label/LabelCustom'
import { ProjectApi } from '../../../../../api/project/project.api'
import { handleTypingLatitudeNumber, handleTypingNumber } from '../../../../../utils/app.utils'
import InputDatePicker from '../../../../../component/input/inputDatePicker'


type Props = {
    updateTrackingProject: (name: string, data: any, mainIndex: number) => void;
    projectDetail: any;
    index: number;
    updateIndicatorTrackingProject: (name: string, value: any, mainIndex: number, detailIndex: number) => void;
}


const TrackingProcess: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const { projectTrack } = props?.projectDetail

    const location = useLocation();
    const isViewCheck: boolean = location.pathname.includes('view');
    // console.log(isViewCheck)

    const [idTrack, setIdTrack] = useState<number>(Number);
    const [track, setTrack] = useState<any[]>([]);
    const [selectedValue, setSelectedValue] = useState<string>('hide');

    const [targetZero, setTargetZero] = useState<string>('hide');
    const [targetOne, setTargetOne] = useState<string>('hide');
    const [targetTwo, setTargetTwo] = useState<string>('hide');

    // ความก้าวหน้าของโครงการที่ดำเนินการกับความเชื่อมโยงกับแผนทั้งสามระดับ
    const [listOne, setListOne] = useState<string>('hide');
    const [listTwo, setListTwo] = useState<string>('hide');
    const [listThree, setListThree] = useState<string>('hide');
    const [listFour, setListFour] = useState<string>('hide');
    const [listFive, setListFive] = useState<string>('hide');

    const [multiValue, setMultiValue] = useState<any>({})


    useEffect(() => {
        setSelectedValue(projectTrack?.asPlanComplete ? 'hide' : 'show')
    }, [projectTrack?.asPlanComplete])
    useEffect(() => {
        setTargetZero(projectTrack?.resultOfTargetProductivity ? 'hide' : 'show')
    }, [projectTrack?.resultOfTargetProductivity])
    useEffect(() => {
        setTargetOne(projectTrack?.resultOfTargetResult ? 'hide' : 'show')
    }, [projectTrack?.resultOfTargetResult])
    useEffect(() => {
        setTargetTwo(projectTrack?.resultOfTargetGroup ? 'hide' : 'show')
    }, [projectTrack?.resultOfTargetGroup])


    // ความก้าวหน้าของโครงการที่ดำเนินการกับความเชื่อมโยงกับแผนทั้งสามระดับ
    useEffect(() => {
        setListOne(projectTrack?.inLineWithNationalStrategy ? 'hide' : 'show')
    }, [projectTrack?.inLineWithNationalStrategy])
    useEffect(() => {
        setListTwo(projectTrack?.inLineWithTargetMain ? 'hide' : 'show')
    }, [projectTrack?.inLineWithTargetMain])
    useEffect(() => {
        setListThree(projectTrack?.inLineWithTargetSub ? 'hide' : 'show')
    }, [projectTrack?.inLineWithTargetSub])
    useEffect(() => {
        setListFour(projectTrack?.inLineWithStrategyProvince ? 'hide' : 'show')
    }, [projectTrack?.lineLineWithStrategyProvince])
    useEffect(() => {
        setListFive(projectTrack?.inLineWithLocal ? 'hide' : 'show')
    }, [projectTrack?.inLineWithLocal])




    const handleGetProjectTrack = async () => {
        await ProjectApi.getProjectTrack()
            .then(res => {
                if (res.status === 200) {
                    setTrack(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    const handleChangeProjectTrack = (name: string, value: any) => {
        props.updateTrackingProject(name, value, props.index)
    }
    const handleChangeTrackingIndicator = (name: string, value: any, detailIndex: number) => {
        props.updateIndicatorTrackingProject(name, value, props.index, detailIndex)
    }

    useEffect(() => {
        handleGetProjectTrack();
    }, [])

    return (
        <div className='w-full'>
            <section className='w-full mt-8'>
                <Typography className='text-primary' variant='h5'>
                    {"การติดตามผลการดำเนินงาน"}
                </Typography>
            </section>
            <section className='grid grid-cols-12 mt-2'>
                <span className='col-span-12 md:col-span-4 lg:col-span-4'>
                    <FilterSelect
                        disabled={isViewCheck}
                        required
                        heading={t("การติดตามผลการดำเนินการ")}
                        renderValue={() => track?.find((list: any) => list?.idTrack === projectTrack?.idTrack)?.trackName}
                        label={t('STATUS.LABEL')}
                        selectId="select-track-ID"
                        value={projectTrack?.idTrack || 0}
                        labelId="label-track-ID"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                            const value = event.target.value
                            value && setIdTrack(Number(value))
                            handleChangeProjectTrack('idTrack', Number(value))
                        }}
                        options={[
                            <MenuItem onClick={() => setIdTrack(0)} disabled value={0}>{"กรุณาเลือก"}</MenuItem>,
                            track && track?.map((list: any) => (
                                <MenuItem key={list?.idTrack} value={list?.idTrack}>
                                    {list?.trackName}
                                </MenuItem>
                            ))]}
                    />
                </span>
            </section>
            {/* {projectTrack?.idTrack === 1 && ( */}
            <>
                {projectTrack?.idTrack === 1 && (
                    <section className='grid grid-cols-12 mt-2'>
                        <span className='col-span-12 md:col-span-4 lg:col-span-4'>
                            <InputDatePicker
                                disabled={isViewCheck}
                                required
                                heading='เมื่อวันที่'
                                onChange={(e) => handleChangeProjectTrack('dateComplete', moment(e).format("YYYY-MM-DD"))}
                                value={projectTrack?.dateComplete}
                            />
                        </span>
                    </section>
                )}
                <RadioGroup
                    aria-label="radio-group"
                    name="radio-group"
                    value={selectedValue}
                    onChange={(e: any) => {
                        setSelectedValue(e.target?.value)
                        handleChangeProjectTrack('asPlanComplete', e.target?.value === 'hide' ? true : false)
                    }}
                >
                    <FormControlLabel value={"hide"} control={<Radio />} label="เป็นไปตามแผน" />
                    <FormControlLabel value={"show"} control={<Radio />} label="ไม่เป็นไปตามแผน" />
                </RadioGroup>
                {!projectTrack?.asPlanComplete && (
                    <InputTextField
                        disablePaddingMultiline
                        multiline
                        inputHeight={'auto'}
                        disabled={isViewCheck}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('asPlanCompleteRemark', e.target.value)}
                        value={projectTrack?.asPlanCompleteRemark}
                        required={selectedValue === 'show'}
                        heading='คำอธิบาย'
                    />
                )}
            </>
            {/* )} */}
            <section className='w-full mt-2'>
                <InputTextField
                    disabled={isViewCheck}
                    name='targetProductivity'
                    disablePaddingMultiline
                    multiline
                    inputHeight={'auto'}
                    row={3}
                    maxRows={10}
                    required
                    heading='เป้าหมายเชิงผลผลิต'
                    value={projectTrack?.targetProductivity}
                    placeholder='ระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('targetProductivity', e.target.value)}
                />
            </section>
            <section className='w-full mt-2'>
                <InputTextField
                    disabled={isViewCheck}
                    disablePaddingMultiline
                    multiline
                    inputHeight={'auto'}
                    row={3}
                    maxRows={10}
                    required
                    heading='เป้าหมายเชิงผลลัพธ์'
                    value={projectTrack?.targetResult}
                    placeholder='ระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('targetResult', e.target.value)}
                />
            </section>
            <section className='w-full mt-2'>
                <InputTextField
                    disabled={isViewCheck}
                    disablePaddingMultiline
                    multiline
                    inputHeight={'auto'}
                    row={3}
                    maxRows={10}
                    required
                    heading='กลุ่มเป้าหมาย/ผู้ได้รับผลประโยชน์'
                    value={projectTrack?.targetGroup}
                    placeholder='ระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('targetGroup', e.target.value)}
                />
            </section>
            <section className='w-full mt-2'>
                <InputTextField
                    multiline
                    maxRows={10}
                    disablePaddingMultiline
                    disabled
                    required
                    heading={`ตัวชี้วัด`}
                    value={`${props.projectDetail?.detailIndicators?.reduce((a: any, b: any) => a + `${props.index === 0 ? b?.indicatorsName : b?.indicators?.indicatorsName}` + ',', '')}`}
                    placeholder='ระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('targetGroup', e.target.value)}
                />
            </section>
            <section className='w-full mt-2'>
                <InputTextField
                    disabled={isViewCheck}
                    multiline
                    row={3}
                    maxRows={10}
                    inputHeight={'auto'}
                    disablePaddingMultiline
                    required
                    heading='ผลที่คาดว่าจะได้รับ'
                    value={projectTrack?.expectedResult}
                    placeholder='โปรดระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('expectedResult', e.target.value)}
                />
            </section>

            <section className='w-full mt-3'>
                <Typography variant='h6'>
                    {"ความก้าวหน้าของโครงการที่ดำเนินการกับความเชื่อมโยงกับแผนทั้งสามระดับ"}
                </Typography>
            </section>

            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='ผลการดำเนินงานต่อเป้าหมายของยุทธศาสตร์ชาติ'
                />
                <RadioGroup
                    aria-label="radio-group-a"
                    name="radio-group-a"
                    value={listOne}
                    onChange={(e: any) => {
                        setListOne(e.target?.value);
                        handleChangeProjectTrack('inLineWithNationalStrategy', e.target?.value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex md:gap-x-36'>
                        <FormControlLabel value={"hide"} control={<Radio />} label="สอดคล้อง" />
                        <FormControlLabel value={"show"} control={<Radio />} label="ไม่สอดคล้อง" />
                    </span>
                    <span>
                        {/* {!projectTrack?.inLineWithNationalStrategy && ( */}
                        <span>
                            <section className='w-full mt-2'>
                                <InputTextField
                                    disabled={isViewCheck}
                                    multiline
                                    inputHeight={'auto'}
                                    disablePaddingMultiline
                                    required
                                    heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมายการดำเนินงานต่อเป้าหมายของยุทธศาสตร์ชาติ)'
                                    value={projectTrack?.resultNationalStrategy}
                                    placeholder='โปรดระบุ'
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultNationalStrategy', e.target.value)}
                                />
                            </section>
                        </span>
                        {/* )} */}
                    </span>
                </RadioGroup>
            </section>
            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='ผลการดำเนินงานต่อเป้าหมายของแผนแม่บทประเด็น'
                />
                <RadioGroup
                    aria-label="radio-group-a"
                    name="radio-group-a"
                    value={listTwo}
                    onChange={(e: any) => {
                        setListTwo(e.target?.value);
                        handleChangeProjectTrack('inLineWithTargetMain', e.target?.value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex md:gap-x-36'>
                        <FormControlLabel value={"hide"} control={<Radio />} label="สอดคล้อง" />
                        <FormControlLabel value={"show"} control={<Radio />} label="ไม่สอดคล้อง" />
                    </span>
                    <span>
                        {/* {!projectTrack?.inLineWithTargetMain && ( */}
                        <span>
                            <section className='w-full mt-2'>
                                <InputTextField
                                    disabled={isViewCheck}
                                    multiline
                                    inputHeight={'auto'}
                                    disablePaddingMultiline
                                    required
                                    heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมายผลการดำเนินงานต่อเป้าหมายของแผนแม่บทประเด็น)'
                                    value={projectTrack?.resultTargetMain}
                                    placeholder='โปรดระบุ'
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultTargetMain', e.target.value)}
                                />
                            </section>
                        </span>
                        {/* )} */}
                    </span>
                </RadioGroup>
            </section>
            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='ผลการดำเนินงานต่อเป้าหมายของแผนย่อย'
                />
                <RadioGroup
                    aria-label="radio-group-a"
                    name="radio-group-a"
                    value={listThree}
                    onChange={(e: any) => {
                        setListThree(e.target?.value);
                        handleChangeProjectTrack('inLineWithTargetSub', e.target?.value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex md:gap-x-36'>
                        <FormControlLabel value={"hide"} control={<Radio />} label="สอดคล้อง" />
                        <FormControlLabel value={"show"} control={<Radio />} label="ไม่สอดคล้อง" />
                    </span>
                    <span>
                        {/* {!projectTrack?.inLineWithTargetSub && ( */}
                        <span>
                            <section className='w-full mt-2'>
                                <InputTextField
                                    disabled={isViewCheck}
                                    multiline
                                    inputHeight={'auto'}
                                    disablePaddingMultiline
                                    required
                                    heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมายผลการดำเนินงานต่อเป้าหมายของแผนย่อย)'
                                    // heading='ระบุเหตุผลที่ไม่เป็นไปตามเป้าหมายผลการดำเนินงานต่อเป้าหมายของแผนย่อย'
                                    value={projectTrack?.resultTargetSub}
                                    placeholder='โปรดระบุ'
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultTargetSub', e.target.value)}
                                />
                            </section>
                        </span>
                        {/* )} */}
                    </span>
                </RadioGroup>
            </section>
            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='ผลดำเนินงานต่อเป้าหมายยุทธศาสตร์จังหวัด'
                />
                <RadioGroup
                    aria-label="radio-group-a"
                    name="radio-group-a"
                    value={listFour}
                    onChange={(e: any) => {
                        setListFour(e.target?.value);
                        handleChangeProjectTrack('inLineWithStrategyProvince', e.target?.value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex md:gap-x-36'>
                        <FormControlLabel value={"hide"} control={<Radio />} label="สอดคล้อง" />
                        <FormControlLabel value={"show"} control={<Radio />} label="ไม่สอดคล้อง" />
                    </span>
                    <span>
                        {/* {!projectTrack?.inLineWithStrategyProvince && ( */}
                        <span>
                            <section className='w-full mt-2'>
                                <InputTextField
                                    multiline
                                    disabled={isViewCheck}
                                    inputHeight={'auto'}
                                    disablePaddingMultiline
                                    required
                                    heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมายผลดำเนินงานต่อเป้าหมายยุทธศาสตร์จังหวัด)'
                                    value={projectTrack?.resultStrategyProvince}
                                    placeholder='โปรดระบุ'
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultStrategyProvince', e.target.value)}
                                />
                            </section>
                        </span>
                        {/* )} */}
                    </span>
                </RadioGroup>
            </section>
            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='ผลการดำเนินงานสอดคล้องกับแผนพัฒนาท้องถิ่น'
                />
                <RadioGroup
                    aria-label="radio-group-a"
                    name="radio-group-a"
                    value={listFive}
                    onChange={(e: any) => {
                        setListFive(e.target?.value);
                        handleChangeProjectTrack('inLineWithLocal', e.target?.value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex md:gap-x-36'>
                        <FormControlLabel value={"hide"} control={<Radio />} label="สอดคล้อง" />
                        <FormControlLabel value={"show"} control={<Radio />} label="ไม่สอดคล้อง" />
                    </span>
                    <span>
                        {/* {!projectTrack?.inLineWithLocal && ( */}
                        <span>
                            <section className='w-full mt-2'>
                                <InputTextField
                                    disabled={isViewCheck}
                                    multiline
                                    inputHeight={'auto'}
                                    disablePaddingMultiline
                                    required
                                    heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมายผลการดำเนินงานสอดคล้องกับแผนพัฒนาท้องถิ่น)'
                                    // heading='ระบุเหตุผลที่ไม่เป็นไปตามเป้าหมายผลการดำเนินงานสอดคล้องกับแผนพัฒนาท้องถิ่น'
                                    value={projectTrack?.resultLocal}
                                    placeholder='โปรดระบุ'
                                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultLocal', e.target.value)}
                                />
                            </section>
                        </span>
                        {/* )} */}
                    </span>
                </RadioGroup>
            </section>

            <section className='w-full mt-1'>
                <Typography variant='h6'>
                    {"พิกัดที่ตั้งโครงการค่าที่ดินและสิ่งก่อสร้าง (เลือกพิกัด)"}
                </Typography>
            </section>
            <section className='flex gap-2 flex-col md:flex-row'>
                <div className='w-full md:w-1/2'>
                    <InputTextField
                        disabled={isViewCheck}
                        type='number'
                        onkeypress={handleTypingLatitudeNumber}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const value = e.target.value;
                            if ((value.length <= 4 || (value.includes('.') && value.split('.')[1].length <= 10))) {
                                handleChangeProjectTrack('latitude', e.target.value)
                            }
                        }}
                        value={projectTrack?.latitude}
                        heading='เส้นรุ้ง (ละติจูด)'
                    />
                </div>
                <div className='w-full md:w-1/2'>
                    <InputTextField
                        disabled={isViewCheck}
                        type='number'
                        onkeypress={handleTypingLatitudeNumber}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const value = e.target.value;
                            if ((value.length <= 4 || (value.includes('.') && value.split('.')[1].length <= 10))) {
                                handleChangeProjectTrack('longitude', e.target.value)
                            }
                        }}
                        value={projectTrack?.longitude}
                        heading='เส้นแวง (ลองติจูด)'
                    />
                </div>
            </section>

            <section className='w-full mt-1'>
                <Typography variant='h6'>
                    {"สรุปปัญหาและข้อเสนอแนะของโครงการ"}
                </Typography>
            </section>

            <section className='w-full mt-2'>
                <InputTextField
                    disabled={isViewCheck}
                    multiline
                    disablePaddingMultiline
                    inputHeight={'auto'}
                    heading='สรุปผลการดำเนินงาน'
                    value={projectTrack?.summaryResult}
                    placeholder='โปรดระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('summaryResult', e.target.value)}
                />
            </section>
            <section className='w-full mt-2'>
                <InputTextField
                    disabled={isViewCheck}
                    multiline
                    disablePaddingMultiline
                    inputHeight={'auto'}
                    heading='ปัญหาและอุปสรรคในการดำเนินงาน'
                    value={projectTrack?.problem}
                    placeholder='โปรดระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('problem', e.target.value)}
                />
            </section>
            <section className='w-full mt-2'>
                <InputTextField
                    disabled={isViewCheck}
                    multiline
                    disablePaddingMultiline
                    inputHeight={'auto'}
                    heading='ข้อเสนอแนะ'
                    value={projectTrack?.suggestions}
                    placeholder='โปรดระบุ'
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('suggestions', e.target.value)}
                />
            </section>

            <section className='w-full mt-1'>
                <Typography variant='h6'>
                    {"การประเมินเป้าหมายและตัวชี้วัดโครงการ"}
                </Typography>
            </section>
            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='เป้าหมายเชิงผลผลิต'
                />
                <RadioGroup
                    aria-label="radio-group-o"
                    name="radio-group-o"
                    value={targetZero}
                    onChange={(e: any) => {
                        const value = e.target?.value
                        setTargetZero(value)
                        value && handleChangeProjectTrack('resultOfTargetProductivity', value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex  md:gap-x-36'>
                        <FormControlLabel value={'hide'} control={<Radio />} label="เป็นไปตามเป้าหมาย" />
                        <FormControlLabel value={'show'} control={<Radio />} label="ไม่เป็นไปตามเป้าหมาย" />
                    </span>
                    <span>
                        {/* {!projectTrack?.resultOfTargetProductivity && ( */}
                        <InputTextField
                            disabled={isViewCheck}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultOfTargetProductivityRemark', e.target.value)}
                            value={projectTrack?.resultOfTargetProductivityRemark}
                            required={!projectTrack?.resultOfTargetProductivity}
                            // heading='ระบุเหตุผลในกรณีที่ไม่เป็นไปตามเป้าหมายเชิงผลผลิต'
                            heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมายเชิงผลผลิต)'
                        />

                        {/* )} */}
                    </span>
                </RadioGroup>
            </section>
            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='เป้าหมายเชิงผลลัพธ์'
                />
                <RadioGroup
                    aria-label="radio-group-a"
                    name="radio-group-a"
                    value={targetOne}
                    onChange={(e: any) => {
                        setTargetOne(e.target?.value);
                        handleChangeProjectTrack('resultOfTargetResult', e.target?.value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex  md:gap-x-36'>
                        <FormControlLabel value={"hide"} control={<Radio />} label="เป็นไปตามเป้าหมาย" />
                        <FormControlLabel value={"show"} control={<Radio />} label="ไม่เป็นไปตามเป้าหมาย" />
                    </span>
                    {/* <span> */}
                    {/* {!projectTrack?.resultOfTargetResult && ( */}
                    <span>
                        <InputTextField
                            disabled={isViewCheck}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultOfTargetResultRemark', e.target.value)}
                            value={projectTrack?.resultOfTargetResultRemark}
                            required={targetOne === 'show'}
                            // heading='ระบุเหตุผลในกรณีที่ไม่เป็นไปตามเป้าหมายเชิงผลลัพธ์'
                            heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมายเชิงผลลัพธ์)'
                        />
                    </span>
                    {/* )} */}
                    {/* </span> */}
                </RadioGroup>
            </section>


            <section className='w-full mt-2'>
                <LabelCustom
                    isRequired
                    text='กลุ่มเป้าหมาย/ผู้ได้รับผลประโยชน์'
                />
                <RadioGroup
                    aria-label="radio-group-b"
                    name="radio-group-b"
                    value={targetTwo}
                    onChange={(e: any) => {
                        setTargetTwo(e.target.value);
                        handleChangeProjectTrack('resultOfTargetGroup', e.target.value === 'hide' ? true : false)
                    }}
                >
                    <span className='flex md:gap-x-36'>
                        <FormControlLabel value={"hide"} control={<Radio />} label="เป็นไปตามเป้าหมาย" />
                        <FormControlLabel value={"show"} control={<Radio />} label="ไม่เป็นไปตามเป้าหมาย" />
                    </span>
                    {/* <span> */}
                    {/* {!projectTrack?.resultOfTargetGroup && ( */}
                    <span>
                        <InputTextField
                            disabled={isViewCheck}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeProjectTrack('resultOfTargetGroupRemark', e.target.value)}
                            value={projectTrack?.resultOfTargetGroupRemark}
                            required={targetTwo === 'show'}
                            // heading='ระบุเหตุผลในกรณีที่ไม่เป็นไปตามกลุ่มเป้าหมาย'
                            heading='ระบุเหตุผล (เป็น/ไม่เป็นไปตามกลุ่มเป้าหมาย)'
                        />
                    </span>
                    {/* )} */}
                    {/* </span> */}
                </RadioGroup>
            </section>


            {projectTrack && projectTrack?.detailTrackIndicators?.map((list: any, i: number) => (
                <section key={i} className='w-full mt-2'>
                    <LabelCustom
                        isRequired
                        text={`ตัวชี้วัด ${i + 1}: ${list?.indicators?.indicatorsName} `}
                    />
                    <RadioGroup
                        defaultValue={list?.result ? 'hide' : 'show'}
                        aria-label={`radio-group-indicator-${i}`}
                        name={`radio-group-indicator-${i}`}
                        value={multiValue[`indicator${i + 1}`]}
                        onChange={(e: any) => {
                            const indicatorKey = `indicator${i + 1}`;
                            setMultiValue((prev: any) => ({ ...prev, [indicatorKey]: e.target.value }));
                            handleChangeTrackingIndicator('result', e.target?.value === 'hide' ? true : false, i);
                        }}
                    >
                        <span className='flex md:gap-x-36'>
                            {['hide', 'show'].map((value, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={value}
                                    control={<Radio />}
                                    label={value === 'hide' ? 'เป็นไปตามเป้าหมาย' : 'ไม่เป็นไปตามเป้าหมาย'}
                                />
                            ))}
                        </span>
                        <span>
                            {/* {projectTrack && list?.result ? (
                                <></>
                            ) : (
                                <span> */}
                            <InputTextField
                                disabled={isViewCheck}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeTrackingIndicator('resultRemark', e.target.value, i)}
                                value={list?.resultRemark}
                                required={multiValue[`indicator${i + 1}`] === 'show' || !list?.result}
                                // heading='ระบุผลลัพธ์ ค่าคะแนนที่ได้และเหตุผลในกรณีที่ไม่เป็นไปตามเป้าหมาย'
                                heading='ระบุผลลัพธ์ค่าคะแนนที่ได้และเหตุผล (เป็น/ไม่เป็นไปตามเป้าหมาย)'
                            />
                        </span>
                        {/* )}
                        </span> */}
                    </RadioGroup>
                </section>
            ))}
        </div>
    )
}

export default TrackingProcess